var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "achievement-list",
      style: { marginTop: _vm.searchComp ? "15px" : "5px" },
    },
    [
      _vm.searchComp
        ? _c("div", { staticClass: "flex items-center achievement-top" }, [
            _vm.achievementData.length !== 0 && _vm.total !== 0
              ? _c("div", [
                  _vm.achievementData.length !== 0 &&
                  _vm.total !== 0 &&
                  !_vm.isDialogText
                    ? _c("div", { staticClass: "all-data-tips" }, [
                        _vm._v(" 为您找到 "),
                        _c("span", [_vm._v(_vm._s(_vm.total) + "条")]),
                        _vm._v(" 结果 "),
                      ])
                    : _c("div", { staticClass: "all-data-tips" }, [
                        _vm.activeValue === "专利"
                          ? _c("div", [
                              _c("p", [
                                _c("span", [_vm._v(_vm._s(_vm.total) + "条")]),
                                _vm._v(" 合作专利 "),
                              ]),
                              _vm._m(0),
                            ])
                          : _vm.activeValue === "论文"
                          ? _c("div", [
                              _c("p", [
                                _c("span", [_vm._v(_vm._s(_vm.total) + "条")]),
                                _vm._v(" 合作论文 "),
                              ]),
                              _vm._m(1),
                            ])
                          : _c("div", [
                              _vm._v(" 为您找到 "),
                              _c("span", [_vm._v(_vm._s(_vm.total) + "条")]),
                              _vm._v(" 结果 "),
                            ]),
                      ]),
                ])
              : _vm._e(),
            _vm.activeValue === "论文" && _vm.searchComp
              ? _c(
                  "div",
                  {
                    staticClass: "flex items-center patent-layout justify-end",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex patent-sort-view" },
                      [
                        _c("span", [_vm._v("排序：")]),
                        _vm._l(_vm.sortData, function (item, index) {
                          return _c(
                            "p",
                            {
                              key: index,
                              staticClass: "pointer",
                              class: [
                                _vm.sortValue == item.name
                                  ? "p-select-color"
                                  : "",
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.clickSortBy(item.name)
                                },
                              },
                            },
                            [
                              index == 1 || index == 2
                                ? _c("span", { staticClass: "sort-line" }, [
                                    _vm._v("|"),
                                  ])
                                : _vm._e(),
                              _vm._v(" " + _vm._s(item.name) + " "),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _c(
            "div",
            {
              staticClass: "achievement-view",
              style: { padding: _vm.searchComp ? "" : "0" },
            },
            [
              _vm.activeValue === "论文"
                ? _c(
                    "div",
                    _vm._l(_vm.achievementData, function (paper) {
                      return _c(
                        "div",
                        {
                          key: paper.id,
                          staticClass: "achievement-item paper-item",
                        },
                        [
                          _c("h3", { staticClass: "title" }, [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetail(
                                      paper.id,
                                      "/paperDetail"
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(paper.title))]
                            ),
                          ]),
                          _c("ul", { staticClass: "info" }, [
                            _c(
                              "li",
                              { staticClass: "inventor ellipsis" },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "min-width": "39px" } },
                                  [_vm._v("作者：")]
                                ),
                                _vm._l(
                                  paper.authors.length < 10
                                    ? paper.authors
                                    : paper.authors.slice(0, 10),
                                  function (author) {
                                    return _c(
                                      "p",
                                      {
                                        key: author.scholarId,
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goPersonalDetails(
                                              author.scholarId || author.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-avatar", {
                                          staticStyle: { "min-width": "22px" },
                                          attrs: {
                                            size: 22,
                                            src: author.avatarUrl,
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "overflow overflow-one",
                                            staticStyle: {
                                              "max-width": "93px",
                                            },
                                            attrs: {
                                              title: author.scholarName,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                author.scholarName ||
                                                  author.name
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c("li", [
                              _c(
                                "span",
                                { staticStyle: { "min-width": "52px" } },
                                [_vm._v("出版物：")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "ellipsis",
                                  staticStyle: { "max-width": "150px" },
                                  attrs: { title: paper.venue },
                                },
                                [_vm._v(" " + _vm._s(paper.venue || "-") + " ")]
                              ),
                            ]),
                          ]),
                          _c("ul", { staticClass: "info" }, [
                            _c("li", [
                              _c("span", [_vm._v("卷号：")]),
                              _c("p", [_vm._v(_vm._s(paper.volume || "-"))]),
                            ]),
                            _c("li", [
                              _c("span", [_vm._v("引用次数：")]),
                              _c("p", [_vm._v(_vm._s(paper.citationNum || 0))]),
                            ]),
                            _c("li", [
                              _c("span", [_vm._v("发表时间：")]),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    paper.date
                                      ? _vm.formatToDate(paper.date)
                                      : "-"
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm.activeValue === "专利"
                ? _c(
                    "div",
                    _vm._l(_vm.achievementData, function (patent) {
                      return _c(
                        "div",
                        { key: patent.id, staticClass: "achievement-item" },
                        [
                          _c("h3", { staticClass: "title" }, [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetail(
                                      patent.id,
                                      "/patentDetail"
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(patent.title))]
                            ),
                          ]),
                          _c("ul", { staticClass: "info" }, [
                            _c(
                              "li",
                              { staticClass: "inventor ellipsis" },
                              [
                                _c("span", [_vm._v("发明人：")]),
                                !patent.authors || patent.authors.length === 0
                                  ? _c("p", [_vm._v("-")])
                                  : _vm._l(
                                      patent.authors.length > 3
                                        ? patent.authors.slice(0, 3)
                                        : patent.authors,
                                      function (author, index) {
                                        return _c(
                                          "p",
                                          {
                                            key: author.scholarId,
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.goPersonalDetails(
                                                  author.scholarId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            index < 6
                                              ? _c("el-avatar", {
                                                  staticStyle: {
                                                    "min-width": "22px",
                                                  },
                                                  attrs: {
                                                    size: 22,
                                                    src: author.avatarUrl,
                                                  },
                                                })
                                              : _vm._e(),
                                            index < 6
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      author.scholarName || "-"
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                              ],
                              2
                            ),
                            _c("li", [
                              _c("span", [_vm._v("申请人：")]),
                              _c("p", [
                                _vm._v(_vm._s(patent.applicantName || "-")),
                              ]),
                            ]),
                            _c("li", [
                              _c("span", [_vm._v("申请时间：")]),
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      patent.applicationDate
                                        ? _vm.formatToDate(
                                            patent.applicationDate
                                          )
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("ul", { staticClass: "info" }, [
                            _c("li", [
                              _c("span", [_vm._v("专利类型：")]),
                              _c("p", [
                                _vm._v(_vm._s(patent.patentType || "-")),
                              ]),
                            ]),
                            _c("li", [
                              _c("span", [_vm._v("公开日期：")]),
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      patent.publicationDate
                                        ? _vm.formatToDate(
                                            patent.publicationDate
                                          )
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("li", [
                              _c("span", [_vm._v("公开(公告)号：")]),
                              _c("p", [
                                _vm._v(_vm._s(patent.publicationNum || "-")),
                              ]),
                            ]),
                            _c("li", { staticStyle: { "margin-top": "6px" } }, [
                              _c("span", [_vm._v("申请号：")]),
                              _c("p", [
                                _vm._v(_vm._s(patent.applicationNum || "-")),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm.activeValue === "项目"
                ? _c(
                    "div",
                    _vm._l(_vm.achievementData, function (project) {
                      return _c(
                        "div",
                        {
                          key: project.id,
                          staticClass: "achievement-item project-item",
                        },
                        [
                          _c("h3", { staticClass: "title" }, [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetail(
                                      project.id,
                                      "/projectDetail"
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(project.title || "-"))]
                            ),
                          ]),
                          _c("ul", { staticClass: "info" }, [
                            project.leader
                              ? _c("li", { staticClass: "inventor ellipsis" }, [
                                  _c("span", [_vm._v("负责人：")]),
                                  project.leader
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goPersonalDetails(
                                                project.leader.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("el-avatar", {
                                            attrs: {
                                              size: 22,
                                              src:
                                                project.leader &&
                                                project.leader.avatar,
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                project.leader &&
                                                  project.leader.scholarName
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _c("p", [_vm._v("-")]),
                                ])
                              : _vm._e(),
                            project.startYear
                              ? _c("li", [
                                  _c("span", [_vm._v("批准年份：")]),
                                  _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(project.startYear || "") +
                                        " "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            project.typeFirst
                              ? _c("li", [
                                  _c("span", [_vm._v("项目类别：")]),
                                  _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(project.typeFirst || "-") +
                                        " "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            project.projectSource
                              ? _c("li", [
                                  _c("span", [_vm._v("项目来源：")]),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(project.projectSource || "-")
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm.activeValue === "奖项"
                ? _c(
                    "div",
                    _vm._l(_vm.achievementData, function (award, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "achievement-item project-item",
                        },
                        [
                          _c("h3", { staticClass: "title" }, [
                            _c("span", [_vm._v(_vm._s(award.awardName))]),
                          ]),
                          _c("ul", { staticClass: "info" }, [
                            _c(
                              "li",
                              { staticClass: "inventor ellipsis" },
                              [
                                _c("span", [_vm._v("获奖人：")]),
                                _vm._l(
                                  award.authors.length < 10
                                    ? award.authors
                                    : award.authors.slice(0, 10),
                                  function (peo) {
                                    return _c(
                                      "p",
                                      {
                                        key: peo.scholarId,
                                        staticClass: "pointer",
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goPersonalDetails(
                                              peo.scholarId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-avatar", {
                                          attrs: {
                                            size: 22,
                                            src: peo.avatarUrl,
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(_vm._s(peo.scholarName)),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            award.awardProject
                              ? _c("li", [
                                  _c("span", [_vm._v("获得奖项：")]),
                                  _c("p", [
                                    _vm._v(_vm._s(award.awardProject || "-")),
                                  ]),
                                ])
                              : _vm._e(),
                            _c("li", [
                              _c("span", [_vm._v("获奖时间：")]),
                              _c("p", [
                                _vm._v(_vm._s(award.year || "-") + "年"),
                              ]),
                            ]),
                            _c("li", [
                              _c("span", [_vm._v("获奖等级：")]),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    award.degree !== 0 ? award.degreeCn : "-"
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm.activeValue !== "相关人才" &&
              _vm.achievementData.length === 0 &&
              _vm.searchComp === false
                ? _c("empty-view")
                : _vm._e(),
              _vm.achievementData.length === 0 && _vm.searchComp === true
                ? _c("div", [_c("el-empty")], 1)
                : _vm._e(),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "hint-text" }, [
      _c("span", [_vm._v("*")]),
      _vm._v("说明：展示与该机构合作过的全部专利 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "hint-text" }, [
      _c("span", [_vm._v("*")]),
      _vm._v("说明：展示与该机构合作过的全部论文 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }